<template>
  <div>
    <div :class="[hasContainerPanel ? 'container-panel' : '']">
      <div v-if="showHeader" class="header">
        <div class="title">
          {{ data.title }}
        </div>
      </div>
      <div
        :class="{
          row: !hasContainerPanel && isVertical,
          'options-vertical': hasContainerPanel && isVertical,
          options: !isVertical,
        }"
      >
        <div
          v-for="item in data.options"
          :key="item.id"
          :class="[!hasContainerPanel && isVertical ? optionCol : '']"
        >
          <div class="row">
            <div class="col">
              <check-box
                :class="isReadOnly ? 'row-check disabled-check' : 'row-check'"
                :disabled="isReadOnly"
                :text="item.name"
                :value="item.checked"
                @input="onCheckChange(item, $event)"
              />
            </div>
            <div v-if="isRecordOther(item)" class="col-8">
              <validation-provider
                v-slot="{ errors }"
                :rules="item.checked ? 'required' : ''"
              >
                <custom-input
                  v-model="item.other"
                  custom-error-msg="El campo es requerido"
                  :disabled="isReadOnly || !item.checked"
                  :error="errors[0]"
                />
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//mixins

//utils

//filters

//components
import CheckBox from 'CheckBox';
import CustomInput from 'CustomInput';

//local-components

//services

//constants
const CHECK_LIKE_IDS = [401, 402, 15];

export default {
  name: 'OptionsPanel',
  components: {
    CheckBox,
    CustomInput,
  },
  mixins: [],
  props: {
    data: {
      type: Object,
      required: true,
    },
    isVertical: {
      type: Boolean,
      default: () => false,
    },
    isReadOnly: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    showHeader: {
      type: Boolean,
      default: () => true,
    },
    optionCol: {
      type: String,
      default: () => 'col-6',
    },
    hasContainerPanel: {
      type: Boolean,
      default: () => true,
    },
    type: {
      type: Number,
      default: () => 0,
    },
  },
  computed: {
    isRecordOther() {
      return (item) => item.isOther;
    },
    isRadioLike() {
      return (item) => this.type === 2 && !CHECK_LIKE_IDS.includes(item.id);
    },
  },
  methods: {
    onCheckChange(item, value) {
      this.$set(item, 'checked', value);

      if (value && this.isRadioLike(item)) {
        this.data.options
          .filter((option) => option.id !== item.id && this.isRadioLike(option))
          .forEach((option) => this.$set(option, 'checked', false));
      }
    },
  },
};
</script>
<style scoped lang="scss">
.container-panel {
  width: 100%;
  background: white;
  overflow: hidden;
  border-radius: 6px;
  outline: 1px #e2e2e2 solid;
  padding: 0px;

  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.header {
  align-self: stretch;
  padding: 16px;
  background: #f7f7f7;

  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;

  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.05);
  border-bottom: 1px #e2e2e2 solid;
}

.title {
  color: #11291b;
  font-size: 16px;
  font-family: Lato;
  font-weight: 700;
  line-height: 21.6px;
}

.options {
  align-self: stretch;
  padding: 24px;
  background: #f7f7f7;

  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
}

.options-vertical {
  align-self: stretch;
  padding: 24px;
  background: #f7f7f7;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.disabled-check {
  ::v-deep(.option-input:disabled:checked + label span) {
    background-color: #3f5b60 !important;
    border-color: #3f5b60 !important;
  }

  ::v-deep(.option-input:disabled:checked + label span .ic-check) {
    background-image: url('../../../../assets/img/icon-check-white.svg') !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: 12px 12px !important;

    width: 20px !important;
    height: 20px !important;
    margin: 0 !important;
    display: block !important;
  }
  ::v-deep(.bg-white) {
    background-color: #c3c3c3 !important;
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>
